module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('list-view', {
    staticClass: "component-photo-panel"
  }, _vm._l((_vm.components), function(component) {
    return _c('div', {
      staticClass: "component-photo",
      style: ({
        backgroundImage: 'url(' + component.photoUrl + ')'
      }),
      on: {
        "click": function($event) {
          _vm.componentPhotoClick(component.detailPhotoUrl)
        }
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-38fe5344!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component-photo-panel.vue
// module id = 196
// module chunks = 5